<template>
    <div
        :class="['SideNav',
                 isOpen ? 'SideNav--open' : 'SideNav--close']"
    >
        <ul
            v-if="!isLoading"
            :class="['SideNav__tab-list',
                     isOpen && 'SideNav__tab-list--open']"
        >
            <li
                :class="`SideNav__header SideNav__header--${isOpen ? 'open' : 'close'}`"
                @click="isOpen = !isOpen"
            >
                <FullLogo
                    v-if="isOpen"
                    class="SideNav__header-logo"
                />
                <StreamlineIcon
                    :class="[
                        'SideNav__menu-icon',
                        isOpen && 'SideNav__menu-icon--open'
                    ]"
                    :icon="menuIcon"
                    fill="#FFFFFF"
                    stroke="transparent"
                    :size="28"
                />
            </li>
            <router-link
                v-for="section in sections"
                :key="section.key"
                v-slot="{ href, route, navigate }"
                :to="section.to"
                tag="li"
            >
                <a
                    :class="[
                        'SideNav__tab',
                        section.key === activeSection.key && 'SideNav__tab--active',
                        isOpen ? 'SideNav__tab--open': 'SideNav__tab--close'
                    ]"
                    :href="href"
                    @click="navigate"
                >
                    <StreamlineIcon
                        :class="[
                            'SideNav__tab-icon',
                            isOpen ? 'SideNav__tab-icon--open': 'SideNav__tab-icon--close',
                            section.key === activeSection.key && 'SideNav__tab-icon--active'
                        ]"
                        :icon="findIcon(section.icon)"
                        stroke="#FFFFFF"
                        :size="24"
                    />
                    <span
                        v-if="isOpen"
                        :class="[
                            'SideNav__tab-text',
                            section.key === activeSection.key && 'SideNav__tab-text--active'
                        ]"
                    >{{ section.label }}</span>
                </a>
            </router-link>
        </ul>
    </div>
</template>
<script>
import FullLogo from '../../../images/logo/white-full-name.svg';
import stat from 'status/index';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {NavigationMenu1, NavigationMenu2} from "@reviewpush/streamline-bold/lib/interface-essential/Menu";
import navIconHelper from './navIconHelper';

export default {
    name: 'RPSideNav',
    components: {
        FullLogo,
        StreamlineIcon
    },
    props: {
        status: {
            type: String,
            default: stat.STANDBY,
        },
        /**
        * See `RPDashboardLayout` for prop details
        */
        sections: {
            type: Array,
            required: true
        },
        /**
        * See `RPDashboardLayout` for prop details
        */
        activeSection: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
            isOpen: false,
        };
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        menuIcon(){
            return this.isOpen
                ? NavigationMenu2
                : NavigationMenu1;
        },
    },
    methods: {
        findIcon(iconName){
            return navIconHelper(iconName);
        }
    }
};
</script>
<style lang="scss">
    .SideNav {
        height: inherit;
        background: $primary-400;

        &--close {
            width: 3rem;
            display: flex;
            justify-content: space-around;}
        &--open { width: 10rem; }

        &__tab-list {
            list-style: none;
            padding: 0;
            margin: 0.5rem 0;
        }

        &__header--open{
            padding: 0.5rem 0 0.5rem 0.5rem;
            display: flex;
            justify-content: space-between;
        }

        &__header-logo{
            height: 1.5rem;
            fill: red;
            margin: auto 0;
        }

        &__menu-icon {
            cursor: pointer;
            height: 1.75rem;
            width: 1.75rem;
            margin: auto;
            opacity: .7;
        }

        &__tab {
            cursor: pointer;
        }
        &__tab--close,
        &__header--close {
            width: 2rem;
            height: 2rem;
            border-radius: 4px;
            background: transparent;
            margin-bottom: 1rem;
            display: flex;
            &:hover {
                background: $highlight-blue;
                opacity: 1;
                .SideNav__tab-icon {
                    opacity: 1;
                }
            }

        }
        &__tab--open {
            background: transparent;
            display: flex;
            padding: 0.5rem;
            align-items: center;
            &:hover {
                background: $highlight-blue;
                .SideNav__tab-text,
                .SideNav__tab-icon {
                    opacity: 1;
                }
            }
            &:active {
                background: $highlight-blue;
            }
        }
        &__tab--active {
            background: $highlight-blue;
        }
        &__tab-icon,
        &__header-icon {
            cursor: pointer;
            width: 1.5rem;
            height: 1.5rem;
        }
        &__tab-icon {
            opacity: .7;
            &--active {
                opacity: 1;
            }
            &--close{
                margin: auto;
            }
        }
        &__tab-text {
            color: $white;
            font-size: 1rem;
            opacity: .7;
            margin-left: 1rem;
            &--active{
                opacity: 1;
            }
        }

    }
</style>

<docs>
```vue
<RPSideNav
    :activeSection="{
        key: 'dashboard',
        label: 'Dashboard',
        icon: 'home',
        to: {
            name: 'Dashboard'
        }
    }"
    :sections="[
        {
            key: 'dashboard',
            label: 'Dashboard',
            icon: 'home',
            to: {
                name: 'Dashboard'
            }
        },
        {
            key: 'locations',
            label: 'Locations',
            icon: 'locations',
            to: {
                name: 'CompanyLocationsTable'
            }
        },
    ]"
>
</RPSideNav>
```
</docs>
